"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _commonConstants = require("../../../utils/common-constants");

var _constants = require("./constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  loading: false,
  error: null,
  data: null
};

var policyViewReducer = function policyViewReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true,
        data: null,
        error: null
      });

    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        data: action.payload,
        error: null
      });

    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action.payload,
        data: null
      });

    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_RESET:
      return _objectSpread(_objectSpread({}, state), initialState);

    default:
      return state;
  }
};

var deleteInitialState = {
  loading: false
};

var policyDeleteReducer = function policyDeleteReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : deleteInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });

    case _constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });

    case _constants.PolicyDeleteDataTypes.POLICY_DELETE_DATA_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });

    default:
      return state;
  }
};

var toggleInitialState = {
  loading: false
};

var policyToggleReducer = function policyToggleReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : toggleInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });

    case _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_COMPLETE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });

    case _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        error: action === null || action === void 0 ? void 0 : action.payload
      });

    case _constants.PolicyViewDataTypes.POLICY_VIEW_TOGGLE_REQUEST_INIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false
      });

    default:
      return state;
  }
};

var initialNotificationMediumState = {
  status: _commonConstants.RESOURCE_STATUS.INITIAL,
  error: null,
  data: {}
};

var notificationMedium = function notificationMedium() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialNotificationMediumState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.LOADING
      });

    case _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_SUCCESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.SUCCESS,
        data: action.payload
      });

    case _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _commonConstants.RESOURCE_STATUS.ERROR,
        error: action.payload
      });

    case _constants.approvalNotificationMediumDetailsType.APPROVAL_NOTIFICATION_MEDIUM_DETAILS_RESET:
      return _objectSpread({}, initialNotificationMediumState);

    default:
      return state;
  }
};

var jsonInitialState = {
  loading: false,
  error: null,
  data: null
};

var policyViewJSONReducer = function policyViewJSONReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : jsonInitialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_LOADING:
      return {
        loading: true,
        data: null,
        error: null
      };

    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_SUCCESS:
      return {
        loading: false,
        data: action.payload,
        error: null
      };

    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: null
      };

    case _constants.PolicyViewDataTypes.POLICY_VIEW_DATA_JSON_RESET:
      return _objectSpread({}, initialState);

    default:
      return state;
  }
};

var viewPolicyReducer = (0, _redux.combineReducers)({
  policyViewReducer: policyViewReducer,
  policyDeleteReducer: policyDeleteReducer,
  policyToggleReducer: policyToggleReducer,
  notificationMedium: notificationMedium,
  policyViewJSONReducer: policyViewJSONReducer
});
var _default = viewPolicyReducer;
exports.default = _default;